import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SvgAccount from '@clearscore/icons.account';
import Text from '@atom/text';

import styles from './account-navigation.css';

const AccountNavigation = ({ firstName, handleAccountToggle, theme }) => {
    const containerClass = cx(styles.container, [styles[theme]]);
    const nameClass = cx(styles.accountNavigationName, [styles[theme]]);

    return (
        <button type="button" className={containerClass} onClick={handleAccountToggle} data-qa="account-open-side-menu">
            <If condition={firstName}>
                <Text body>
                    <span className={nameClass}>Hi {firstName}</span>
                </Text>
            </If>
            <SvgAccount />
        </button>
    );
};

AccountNavigation.themes = {
    DEFAULT: 'onBackground',
    WHITE: 'onWhite',
};

AccountNavigation.propTypes = {
    firstName: PropTypes.string,
    handleAccountToggle: PropTypes.func,
    theme: PropTypes.string,
};

AccountNavigation.defaultProps = {
    firstName: undefined,
    handleAccountToggle: () => {},
    theme: AccountNavigation.themes.DEFAULT,
};

export default AccountNavigation;
